import { v4 } from 'uuid';
import { ColorGenerator } from '../ColorGenerator.class';
import { DynamicFlatNode } from '../DynamicFlatNode.class';
import { AggregationFunction, TimeUnit, TreeEntityType } from '../enum';
import type { StoreControl } from '../interfaces/storecontrol.interface';
import type { OrgaElementModel } from '../OrgaElementModel';

export class Control implements StoreControl {
  /**
   *
   */
  isHidden = false;
  /**
   *
   */
  level?: number;
  /**
   *
   */
  expanded?: boolean;
  /**
   *
   */
  thresholds?: { show?: boolean; stops: { value: number; color: string }[] };
  /**
   *
   */
  confidenceBand?: boolean = false;
  /**
   *
   */
  color?: string;
  /**
   *
   */
  label!: string;
  /**
   *
   */
  raw_label!: string;
  /**
   *
   */
  formControl!: string;
  /**
   *
   */
  datasource!: string;
  /**
   *
   */
  unit?: string = '';
  /**
   * stores the mathematical transformation for each datapoint in timeseries of this channel
   */
  transformation = '';
  /**
   * to indentify a virtual channel
   */
  isVirtual = false;
  /**
   *
   */
  windowUnit: TimeUnit = TimeUnit.Day;
  /**
   *
   */
  aggFunction: AggregationFunction = AggregationFunction.Avg;
  /**
   *
   */
  windowSize = 1;
  /**
   *
   */
  description?: string = '';
  /**
   *
   */
  seriesOverride: any = {
    smooth: false,
    type: 'line',
  };
  /**
   * the symbol to display in the linechart
   */
  symbol?: string = 'none';
  /**
   *
   */
  id = '';
  /**
   *
   */
  isOffline = false;
  /**
   *
   */
  entity?: OrgaElementModel | any;
  /**
   *
   * @param arg0
   */
  constructor(arg0?: Partial<Control>) {
    if (arg0) {
      Object.assign(this, arg0);
    }
    if (!this.id) {
      this.id = v4();
    }
    this.color ??= ColorGenerator.getColor();
  }
  /**
   * used to get values from the dataTable store back again
   */
  get mappingString() {
    if (!this.isOffline) {
      return `${this.id}_${this.windowSize}_${TimeUnit[this.windowUnit]}_${AggregationFunction[this.aggFunction]}`;
    } else if (this.isOffline) {
      return `${this.entity?.parentIdentifier}`;
    }
    return '';
  }
  /**
   * used to get values from the dataTable store back again
   */
  get min_label() {
    return `${this.label}_min_avg`;
  }
  /**
   * used to get values from the dataTable store back again
   */
  get max_label() {
    return `${this.label}_max_avg`;
  }
  /**
   *
   */
  user_label = '';
  /**
   *
   */
  get store(): StoreControl {
    return {
      aggFunction: this.aggFunction,
      color: this.color,
      confidenceBand: this.confidenceBand,
      datasource: this.datasource,
      description: this.description,
      entity: this.entity,
      expanded: this.expanded,
      formControl: this.formControl,
      id: this.id,
      isHidden: this.isHidden,
      isOffline: this.isOffline,
      isVirtual: this.isVirtual,
      label: this.label,
      level: this.level,
      raw_label: this.raw_label,
      seriesOverride: this.seriesOverride,
      symbol: this.symbol,
      thresholds: this.thresholds,
      transformation: this.transformation,
      unit: this.unit,
      user_label: this.user_label,
      windowSize: this.windowSize,
      windowUnit: this.windowUnit,
    };
  }
  /**
   *  creates an DFN out of the Control
   * @returns
   */
  toDynamicFlatNode() {
    return new DynamicFlatNode({
      entity: this.store,
      expandable: false,
      isLoading: false,
      id: this.id,
      label: this.label,
      level: 5,
      type: TreeEntityType.CHANNEL,
    });
  }
  static sortByRawLabel(a: Control, b: Control) {
    return a.label.localeCompare(b.label);
  }
  setTime(arg0: { windowUnit: TimeUnit; windowSize: number }) {
    this.windowSize = arg0.windowSize;
    this.windowUnit = arg0.windowUnit;
  }
}
